/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.05.17.
 */

import React from "react";
import PropTypes from "prop-types";

class NavbarSearch extends React.Component {
    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <li>
            </li>
        );
        /*
        return (
            <form role="search" className="navbar-form" action="search.html">
                <div className="form-group">
                    <div className="input-group">
                        <input type="text" placeholder="Search by name..." className="form-control"
                               name="top-search" id="top-search"/>
                        <span className="input-group-btn">
                                        <button className="btn btn-default" type="submit"><i
                                            className="fa fa-search"></i></button>
                                    </span>
                    </div>
                </div>
            </form>
        );
        */
    }
}

export default NavbarSearch;
